import React from "react";
import loadable from "@loadable/component";
import PropTypes from "prop-types";

const metas = {
    page: loadable(() => import("./PageMeta")),
    pagination: loadable(() => import("./PaginationMeta")),
    product: loadable(() => import("./ProductMeta")),
};

const Meta = ({ layout, ...rest }) => {
    const MetaComponent = metas[layout];

    return <MetaComponent {...rest} />;
};

Meta.propTypes = {
    layout: PropTypes.string.isRequired,
};

export default Meta;
